<div
  class="report-discrepancies-link"
  data-cy="nutritional-info-report-discrepancies-link"
  id="pdp-report-discrepancies"
>
  <ion-button (click)="reportDiscrepancies()">
    {{ 'i18n.productDetail.nutritionalInfo.reportDiscrepancies' | translate }}
  </ion-button>
</div>
